import React, { useEffect, useMemo } from 'react';
import style from './PostMarketLink.module.css';
import links from '../../Assets/links.svg';
import Gallery from '../../Assets/Gallery.svg';
import send from '../../Assets/send.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import * as api from '../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import { studentActions } from '../../redux/actions';
import Swal from 'sweetalert2';
import BackIcon from '../../Assets/BackIcon.svg';
import { Box, Spinner, useDisclosure } from '@chakra-ui/react';
import Img from '../../Assets/Img.svg';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react';

const PostMarketLink = () => {
  const dispatch = useDispatch();
  const students = useSelector((state) => state.student);
  const location = useLocation();

  const title = location.search.split('title=')[1].split('&')[0];
  const type = location.search.split('type=')[1].replace(/%20/g, ' ');

  const [image, setImage] = useState('');
  const [video, setVideo] = useState('');
  const [link, setLink] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // preview
  const preview = useMemo(() => {
    return image && typeof image !== 'string'
      ? URL.createObjectURL(image)
      : null;
  }, [image]);

  const videoHanlder = (video) => {
    return URL.createObjectURL(video);
  };
  const submitHandler = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('projectTitle', title);
    formData.append('projectType', type);
    formData.append('file', image);
    formData.append('file', video);
    formData.append('url', link);
    let response;
    if (link) {
      response = await api.uploadYoutubeLink({
        url: link,
        projectTitle: title,
        projectType: type,
      });
    }
    if (video || image) {
      response = await api.uploadWork(formData);
    }
    var youtubeRegex = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
    var imageRegex = /\.(jpeg|jpg|png|gif)$/i;

    function isValidURL() {
      if (youtubeRegex.test(students.portfolio.url)) {
      } else if (imageRegex.test(students.portfolio)) {
      }
    }
    isValidURL();
    if (response.status === 201) {
      setLoading(false);
    }
    if (response.status === 201) {
      // Swal.fire("Project Created Successfully");
      Swal.fire({
        icon: 'success',
        text: 'Project Created Successfully',
        timer: 1300,
      });
    }
    setLoading(false);
    navigate('/hiring/student/portfolio');
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user._id;
    dispatch(studentActions.setStudent(userId));
  }, []);
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div className={style.container}>
      <div className={style.start}>Start Building Project</div>
      <div className={style.startBack}>
        <div>
          <img
            src={BackIcon}
            alt=''
            onClick={() => navigate(-1, { replace: true })}
          />
        </div>
        <div className={style.starting}>Start Building Project</div>
      </div>

      <div className={style.imageVideoContainer}>
        <div className={style.images}>
          <label className={style.image} style={{ cursor: 'pointer' }}>
            <input
              type='file'
              accept='image/jpeg, image/png, image/gif, image/jpg'
              onChange={(e) => setImage(e.target.files[0])}
              hidden
            />

            {image ? (
              <img src={preview} alt='profile' />
            ) : (
              <img src={Img} alt='profile' />
            )}
          </label>
          {/* <Box
            onClick={onOpen}
            className={style.image}
            style={{ cursor: 'pointer' }}
          >
            <img src={Img} alt='img' />
          </Box> */}
          {/* <div
            style={{ padding: '1rem', fontWeight: 400, fontFamily: 'Roboto' }}
          >
            image
          </div> */}

          {image && (
            <Modal closeOnOverlayClick={false} isOpen={image ? true : false}>
              <ModalOverlay />
              <ModalContent h='500px' w='600px'>
                <ModalBody>
                  <Box>
                    {/* <input
                    type='file'
                    onChange={(e) => setImage(e.target.files[0])}
                  /> */}

                    <div className={style.postlinkImg}>
                      <div className={style.previewTxt}>Preview </div>

                      {image ? <img src={preview} alt='profile' /> : ''}
                    </div>
                  </Box>
                </ModalBody>

                <ModalFooter
                  alignItems={'center'}
                  margin={'auto'}
                  pt={'1px'}
                  className={style.previewbtn}
                >
                  <button
                    colorScheme='blue'
                    mr={3}
                    disabled={loading}
                    onClick={submitHandler}
                    onClose
                  >
                    {loading ? <Spinner /> : 'Finish'}
                  </button>
                  <button
                    onClick={() => navigate(-1, { replace: true })}
                    style={{
                      background: '#FFFFFF',
                      color: '#000000',
                      border: '1px solid #CECCD1',
                    }}
                  >
                    Discard
                  </button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          )}

          <div
            style={{ padding: '1rem', fontWeight: 400, fontFamily: 'Roboto' }}
          >
            image
          </div>
        </div>
        <div className={style.images}>
          <label className={style.video} style={{ cursor: 'pointer' }}>
            <input
              type='file'
              accept='video/mp4,video/x-m4v,video/mkv,video/avi,video/mov,video/3gp,video/webm'
              onChange={(e) => setVideo(e.target.files[0])}
              hidden
              style={{ cursor: 'pointer' }}
            />
            <img src={send} alt='video' />
            {video && (
              <Modal
                closeOnOverlayClick={false}
                isOpen={image || video ? true : false}
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalBody pb={6}>
                    <Box>
                      {/* <input
                    type='file'
                    onChange={(e) => setImage(e.target.files[0])}
                  /> */}
                      <div className={style.postlinkImg}>
                        <div className={style.previewTxt}>Preview </div>
                        {video ? (
                          <video
                            src={videoHanlder(video)}
                            alt='profile'
                            controls
                            height='200px'
                            width='300px'
                          />
                        ) : (
                          ''
                        )}
                      </div>
                    </Box>
                  </ModalBody>

                  <ModalFooter className={style.previewbtn}>
                    <button
                      colorScheme='blue'
                      mr={3}
                      disabled={loading}
                      onClick={submitHandler}
                    >
                      {loading ? <Spinner /> : 'Finish'}
                    </button>
                    <button
                      onClick={() => navigate(-1, { replace: true })}
                      style={{
                        background: '#FFFFFF',
                        color: '#000000',
                        border: '1px solid #CECCD1',
                      }}
                    >
                      Discard
                    </button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            )}
          </label>
          <div
            style={{ padding: '1rem', fontWeight: 400, fontFamily: 'Roboto' }}
          >
            Video
          </div>
          {/* <Box
            onClick={onOpen}
            className={style.image}
            style={{ cursor: 'pointer' }}
          >
            <img src={send} alt='img' />
          </Box>
           <div
            style={{ padding: '1rem', fontWeight: 400, fontFamily: 'Roboto' }}
          >
            Video
          </div> */}
          {/* <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Box>
                  <input
                    type='file'
                    onChange={(e) => setImage(e.target.files[0])}
                  />
                  {image ? <img src={preview} alt='profile' /> : ''}
                </Box>
              </ModalBody>

              <ModalFooter>
                <Button colorScheme='blue' mr={3} onClick={submitHandler}>
                  Finsh
                </Button>
                <Button onClick={() => navigate(-1, { replace: true })}>
                  Discard
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal> */}
        </div>
      </div>
      <div className={style.horizontal}>
        <div className={style.hr}></div>
        <div className={style.or}>or</div>
        <div className={style.hr1}></div>
      </div>
      <div className={style.projectText}>Post Market place project Link</div>
      <form className={style.form}>
        <img src={links} alt='' />
        <input
          type='text'
          placeholder='Post Link here'
          value={link}
          onChange={(e) => setLink(e.target.value)}
          style={{ padding: '0.5rem', width: '100%' }}
        />
      </form>
      <div></div>
      <div className={style.btns}>
        <div
          className={style.nextBtns}
          onClick={submitHandler}
          style={{ pointerEvents: loading ? 'none' : 'all' }}
        >
          {loading && !image && !video ? <Spinner /> : 'Finish'}
        </div>

        <div
          className={style.nextBtns}
          onClick={() => navigate(-1, { replace: true })}
        >
          Discard
        </div>
      </div>
    </div>
  );
};
export default PostMarketLink;
